module.exports = __webpack_public_path__ + "static/media/rank2.ee020969.png";